import { Heading, Stack, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { createDemand } from '../api'
import { DemandForm } from '../components/DemandForm'
import type { ApiError, CreateDemandPayload } from '../types'

export function CreateDemandPage() {
  const navigate = useNavigate()

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<ApiError | null>(null)

  async function handleSubmit(payload: CreateDemandPayload) {
    try {
      setIsSubmitting(true)
      setError(null)

      const demand = await createDemand(payload)

      navigate(`/union/demands/${demand.id}`)
    } catch (requestError) {
      setError(requestError as ApiError)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Stack gap={6} maxW="3xl">
      <Stack gap={1}>
        <Heading size="lg">Create demand</Heading>
        <Text color="fg.muted">Describe the required service so matching SIBs can be found.</Text>
      </Stack>

      <DemandForm isSubmitting={isSubmitting} error={error} onSubmit={handleSubmit} />
    </Stack>
  )
}
